import axios from "axios";
// import dotenv from "dotenv";
// const THETA_KEY = process.env.NEXT_THETA_KEY;
// const THETA_SECRET = process.env.NEXT_THETA_SECRET;
const THETA_KEY = "srvacc_sgihghmxzurck034t1a33qha9";
const THETA_SECRET = "yrkzah5gr4iynsjbh6b5bwwip1fw5avu";

const ThetaVideoAPI = {
  BASE_URL: "https://api.thetavideoapi.com",

  getVideos: async function (page: Number, size: Number = 8) {
    try {
      const response = await axios.get(
        `${this.BASE_URL}/video/${THETA_KEY}/list?page=${page}&number=${size}`,
        {
          headers: {
            "x-tva-sa-id": THETA_KEY,
            "x-tva-sa-secret": THETA_SECRET,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  getVideo: async function (id: String) {},

  uploadVideo: async function (fileContents: any) {
    console.log(THETA_KEY, THETA_SECRET);
    try {
      const createURL = await axios.post(`${this.BASE_URL}/upload`, null, {
        headers: {
          "x-tva-sa-id": THETA_KEY,
          "x-tva-sa-secret": THETA_SECRET,
        },
      });

      const data = createURL.data.body.uploads[0];

      await axios.put(data.presigned_url, fileContents, {
        headers: {
          "x-tva-sa-id": THETA_KEY,
          "x-tva-sa-secret": THETA_SECRET,
          "Content-Type": "application/octet-stream",
        },
      });

      const options = {
        source_upload_id: data.id,
        playback_policy: "public",
      };

      const transcodeResult = await axios.post(
        `${this.BASE_URL}/video`,
        options,
        {
          headers: {
            "x-tva-sa-id": THETA_KEY,
            "x-tva-sa-secret": THETA_SECRET,
            "Content-Type": "application/json",
          },
        }
      );

      const transcodeData = transcodeResult.data.body;

      console.log("transcode result", transcodeData);

      const getVideo = await axios.get(
        `${this.BASE_URL}/video/${transcodeData.videos[0].id}`,
        {
          headers: {
            "x-tva-sa-id": THETA_KEY,
            "x-tva-sa-secret": THETA_SECRET,
          },
        }
      );

      console.log("get video response", getVideo.data.body);

      return getVideo;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  getLiveStreams: async function () {
    try {
      const response = await axios.get(
        `${this.BASE_URL}/video/${THETA_KEY}/streams`,
        {
          headers: {
            "x-tva-sa-id": THETA_KEY,
            "x-tva-sa-secret": THETA_SECRET,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  createLiveStream: async function (name: String) {
    try {
      const options = {
        name: name,
        resolutions: ["160p", "240p", "360p", "720p", "source"],
        source_resolution: "720p",
        fps: 60,
      };

      const createURL = await axios.post(`${this.BASE_URL}/stream`, options, {
        headers: {
          "x-tva-sa-id": THETA_KEY,
          "x-tva-sa-secret": THETA_SECRET,
          "Content-Type": "application/json",
        },
      });

      return createURL.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  retrieveStream: async function (streamId: String) {
    try {
      const response = await axios.get(`${this.BASE_URL}/stream/${streamId}`, {
        headers: {
          "x-tva-sa-id": THETA_KEY,
          "x-tva-sa-secret": THETA_SECRET,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
};

export default ThetaVideoAPI;
